import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'last4digits'
})
export class Last4digitsPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    if (value) {
      return ('*****' + value.substring(value.length - 4, value.length));
    }

    return null;
  }

}

